import React from 'react';
import {View} from 'react-native';
import Svg, {Path} from 'react-native-svg';

/**
 * The puzzle-piece glyph that stands for "active puzzles".
 *
 * Drawn rather than taken from an icon font. Ionicons' `extension-puzzle`
 * exists in the npm glyph map but not in the older Ionicons font the web
 * build ships (babel-preset-expo swaps react-native-vector-icons for
 * @expo/vector-icons), so it rendered as a "?". The font components also load
 * their font on mount, which jest cannot do. This is Material Design Icons'
 * `puzzle` path (Apache-2.0, already in the app's MaterialCommunityIcons font).
 *
 * Decorative: it always sits beside the words it illustrates.
 */
const PUZZLE_PATH =
  'M20.5,11H19V7C19,5.89 18.1,5 17,5H13V3.5A2.5,2.5 0 0,0 10.5,1A2.5,2.5 0 0,0 ' +
  '8,3.5V5H4A2,2 0 0,0 2,7V10.8H3.5C5,10.8 6.2,12 6.2,13.5C6.2,15 5,16.2 ' +
  '3.5,16.2H2V20A2,2 0 0,0 4,22H7.8V20.5C7.8,19 9,17.8 10.5,17.8C12,17.8 ' +
  '13.2,19 13.2,20.5V22H17A2,2 0 0,0 19,20V16H20.5A2.5,2.5 0 0,0 23,13.5A2.5,2.5 ' +
  '0 0,0 20.5,11Z';

export default function PuzzleIcon({
  size = 16,
  color,
}: {
  size?: number;
  color: string;
}) {
  return (
    <View
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      {...({'aria-hidden': true} as any)}
      style={{width: size, height: size}}>
      <Svg width={size} height={size} viewBox="0 0 24 24">
        <Path d={PUZZLE_PATH} fill={color} />
      </Svg>
    </View>
  );
}
